import { gql } from '@apollo/client'

export default gql(`
query getEpg {
    getEpgConfigSetting {
        id
        status
        url
        frequency
        fileName
        lastRunTime
    }
}`)
